import React from 'react';
import cn from 'classnames';

import LogoIcon from 'widget/shared/icons/brand/LogoIcon';
import TitleIcon from 'widget/shared/icons/brand/TitleIcon';

import styles from './Logo.module.scss';

export type LogoProps = {
  className?: string;
  withTitle?: boolean;
};

const Logo: React.FC<LogoProps> = ({ className, withTitle }) => {
  return (
    <div className={cn(styles['logo'], className)}>
      <LogoIcon size={29} />
      {withTitle && <TitleIcon height={19} width={142} />}
    </div>
  );
};

export default Logo;
